<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="supplierPayable">
            <van-nav-bar
                title="供应商应付"
                left-arrow
                @click-left="onClickLeft"
                @click-right="showFilterPop = true"
            >
                <template #right>
                    <img class="shaixuan" src="../../../../../assets/images/leadingCockpit/shaixuan.png">
                </template>
            </van-nav-bar>
            <filterConditions
                :show-filter-pop.sync="showFilterPop"
                @sureBack="sureBack"
            ></filterConditions>
            <van-search v-model="searchValue" @change="search" placeholder="请输入供应商名称查询"></van-search>
            <div class="btns">
                <template v-for="(item, index) in timeType">
                    <button
                        :class="{'active': selectType == index}"
                        @click="switchingTimeType(index)"
                        :key="index"
                    >
                        {{ item.name }}
                    </button>
                </template>
            </div>
            <div class="timeSlot" v-if="selectType == 2">
                <div class="startTime iconfont iconshijian" @click="openSelectTime('startTime', beginDate)">
                    <p>{{ beginDate }}</p>
                </div>
                <span>—</span>
                <div class="endTime iconfont iconshijian" @click="openSelectTime('endTime', endDate)">
                    <p>{{ endDate }}</p>
                </div>
            </div>
            <section
                :class="['van-pull-refresh', {'sectionHeight': selectType == 2}]"
            >
                <template v-for="(item, index) in supplierListData">
                    <div class="supplierList" :key="index" @click="openContractDetails(item)">
                        <h3>供应商名称：{{ item.supplier_name }}</h3>
                        <div class="money">
                            <div>
                                <p>{{ item.payable }}</p>
                                <span>累计应付(元)</span>
                            </div>
                            <div>
                                <p>{{ item.actually_paid }}</p>
                                <span>累计实付(元)</span>
                            </div>
                            <div>
                                <p>{{ item.balance }}</p>
                                <span>当前应付余额(元)</span>
                            </div>
                        </div>
                        <div class="contractData">
                            <h5>合同数量：{{ item.contract_num }}</h5>
                            <p>{{ item.contract_names }}</p>
                        </div>
                        <div class="contractData tenant_name">
                            <p>采购企业:{{ item.tenant_names }}</p>
                        </div>
                    </div>
                </template>
                <van-loading size="24px" vertical v-show="loading">
                    加载中...
                </van-loading>
                <p v-show="!loading&&supplierListData.length==0" class="empty-data">
                    暂无数据
                </p>
            </section>

            <van-popup v-model="showCalendarPop" position="bottom" :style="{ height: '50%' }">
                <van-datetime-picker
                    v-model="currentDate"
                    type="date"
                    title="选择年月日"
                    :min-date="minDate"
                    @confirm="confirmDate"
                    @cancel="cancelDate"
                ></van-datetime-picker>
            </van-popup>
        </div>
    </v-touch>
</template>
<script>
import filterConditions from '../../filterConditions/index';
export default {
    // 供应商应付
    name: 'data-supplier-payable',
    components: {
        filterConditions,
    },
    props: {},
    beforeRouteLeave(to, from, next) {
        if (to.path === '/dataReport') {
            this.$store.commit('noKeepAlive', 'data-supplier-payable');
        }
        next();
    },
    data() {
        return {
            loading: true,
            showFilterPop: false,
            activeIndex: 0,
            // 选择时间
            showCalendarPop: false,
            // 选择时间类型（开始时间，结束时间）
            selectTimeType: '',
            // 开始时间
            beginDate: '',
            // 结束时间
            endDate: '',
            // 选择时间控件默认时间
            currentDate: '',
            // 时间控件最小时间
            minDate: new Date(2000, 0, 1),
            // 查询条件
            searchValue: '',
            // 时间类型
            timeType: [{
                name: '当前',
                val: 0,
            }, {
                name: '本年',
                val: 1,
            }, {
                name: '时间段',
                val: 2,
            }],
            // 选中时间类型
            selectType: 0,
            // 供应商应付列表数据
            supplierListData: [],
            filterData: {},
        };
    },
    computed: {},
    watch: {
        selectType(newVal) {
            if (newVal === 0) {
                this.beginDate = '';
                this.endDate = '';
                // 获取供应商应付列表数据
                this.getSupplierListData();
            } else if (newVal === 1) {
                const nweYear = new Date().getFullYear();
                this.beginDate = nweYear + '-01-01';
                const newToday = this.formatDate();
                this.endDate = newToday;
                // 获取供应商应付列表数据
                this.getSupplierListData();
            } else if (newVal === 2) {
                const nweYear = new Date().getFullYear();
                this.beginDate = nweYear + '-01-01';
                const newToday = this.formatDate();
                this.endDate = newToday;
            }
        },
    },
    created() {
        this.beginDate = '';
        // this.beginDate = '2000-01-01';
        // const newToday = this.formatDate();
        this.endDate = '';
        // 获取供应商应付列表数据
        this.getSupplierListData();
    },
    mounted() {},
    destroyed() {},
    methods: {
        sureBack(params) {
            this.filterData = params;
            this.getSupplierListData();
        },
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 打开选择时间
        openSelectTime(type, time) {
            this.currentDate = new Date(time);
            this.selectTimeType = type;
            this.showCalendarPop = true;
        },
        // 确认选择时间
        confirmDate(value) {
            if (this.selectTimeType === 'startTime') {
                const newDate = this.formatDate(value);
                this.beginDate = newDate;
            } else if (this.selectTimeType === 'endTime') {
                const newDate = this.formatDate(value);
                this.endDate = newDate;
            }
            this.showCalendarPop = false;
            // 获取供应商应付列表数据
            this.getSupplierListData();
        },
        // 取消选择时间
        cancelDate() {
            this.showCalendarPop = false;
        },
        // 条件查询
        search() {
            this.getSupplierListData();
        },
        // 获取供应商应付列表数据
        getSupplierListData() {
            this.loading = true;
            this.supplierListData = [];
            const data = {
                supplierName: this.searchValue,
                startDate: this.beginDate,
                endDate: this.endDate,
                yun_yq_id: this.filterData.yun_yq_id,
                pian_q_id: this.filterData.pian_q_id,
                qi_y_id: this.filterData.qi_y_id,
            };
            this.$axios
                .post('/interfaceApi/report/procurement/supplier_accounts', data)
                .then(res => {
                    this.supplierListData = res;
                })
                .catch(error => {
                    this.$toast.fail(error.ErrorCode.Message);
                }).finally(() => {
                    this.loading = false;
                });
        },
        // 打开合同详情
        openContractDetails(data) {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'dataSupplierContract',
                params: {
                    supplierId: data.supplier_id,
                    supplierName: data.supplier_name,
                    selectType: this.selectType,
                    beginDate: this.beginDate,
                    endDate: this.endDate,
                },
            });
        },
        // 切换时间段类型
        switchingTimeType(index) {
            this.selectType = index;
        },
        // 格式化日期
        formatDate(date) {
            if (date) {
                date = new Date(date);
            } else {
                date = new Date();
            }
            const Y = date.getFullYear();
            let M = date.getMonth() + 1;
            let D = date.getDate();
            M = M < 10 ? '0' + M : M;
            D = D < 10 ? '0' + D : D;
            return Y + '-' + M + '-' + D;
        },
    },
};
</script>
<style lang="stylus">
.supplierPayable
    height 100%
    .empty-data
        font-size 28rpx
        line-height 200rpx
        text-align center
        color #ccc
    .van-nav-bar__right
        right 15rpx!important;
        width 0
        .shaixuan
            width 18rpx;
    .van-tabs
        .van-tabs__wrap
            height 44rpx
            .van-tabs__nav--line
                padding-bottom 0
            .van-tabs__line
                bottom 0
            .van-tab__text
                color #666666
                font-size 14rpx
            .van-tab--active
                .van-tab__text
                    color #E60000
    .timeSlot
        height 36rpx
        border 1px solid #D7D7D7
        border-radius 4rpx
        margin 0 15rpx 12rpx 15rpx
        box-shadow 2px 2px 8px rgba(84, 148, 243, 0.2)
        display flex
        justify-content center
        >span
            width 24rpx
            line-height 32rpx
            color #D7D7D7
            text-align center
            margin 0 14rpx;
        >div
            &:before
                color #979EA7
                line-height 32rpx
                font-size 14rpx
            p
                display inline-block
                color #061F3E
                font-size 12rpx
                padding-left 6rpx
    .btns
        display flex
        margin 15rpx
        button
            width 90rpx
            height 30rpx
            color #666666
            margin 0 15rpx
            font-size 14rpx
            border 1px solid #D7D7D7
            border-radius 4rpx
            background #fff
            box-shadow 2px 2px 8px rgba(84, 148, 243, 0.2)
            &.active
                color #fff
                border-color #0E84FF
                background #3495FB
                box-shadow 2px 2px 8px #5494F3
    section
        height calc(100% - 135rpx)
        padding 0 15rpx 15rpx 15rpx
        -webkit-overflow-scrolling touch
        overflow scroll
        &.sectionHeight
            height calc(100% - 195rpx)
        .supplierList
            border-radius 4rpx
            margin-bottom 15rpx
            border 1px solid #D7D7D7
            box-shadow 2px 2px 8px rgba(84, 148, 243, 0.5)
            h3
                height 40rpx
                color #333333
                font-size 14rpx
                line-height 40rpx
                padding-left 15rpx
                overflow hidden
                text-overflow ellipsis
                white-space nowrap
                background rgba(85, 136, 241, 0.06)
            .money
                padding 10rpx
                display flex
                border-bottom 1px solid #F0F0F0
                p
                    color #666666
                    font-size 16rpx
                span
                    font-size 12rpx
                    color #979EA7
                div
                    flex 1
                    &:nth-of-type(3)
                        padding 3rpx 10rpx
                        background rgba(250, 132, 54, 0.06)
                        p
                            color #FF6600
                        span
                            color #666666
            .contractData
                padding 15rpx 15rpx 15rpx 40rpx
                background url(../../../../../assets/images/icons/icon_gy_1.png) 15rpx 15rpx no-repeat
                background-size 16rpx
                h5
                    font-size 14rpx
                    color #419DFF
                    margin-bottom 7rpx
                    text-decoration underline
                p
                    font-size 14rpx
                    line-height 20rpx
                    color #666666
            .tenant_name
                background url(../../../../../assets/images/icons/icon_gy_8.png) 15rpx 15rpx no-repeat
                background-size 16rpx
                margin-top -20rpx;

</style>
